/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutItemWrapSX } from '@/components/layouts/styles/itemWrap';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { useTheme } from '@mui/material/styles';
import { Container, Grid, Stack } from '@mui/material';
import { FC } from 'react';

export const ContentPageLayout: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		customDimensions: { layoutSpacing },
	} = useTheme();
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
				<Stack
					id="main-content"
					component="main"
					gap={layoutSpacing}
					sx={layoutMainSX(layout.slots.first?.length || 0)}
				>
					<Container component="section">
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.first} /></Grid>
						</Grid>
					</Container>
	    	</Stack>
			<LayoutSlot slot={layout.slots.footer} />
		</>
	) : null;
};
